import styles from './FJMediaDuration.module.less';
import classNames from 'classnames';

interface Props {
    duration: string,
    className?: string
}

const FJMediaDuration = ({ duration = '0', className = '' }: Props) => {
    return (
        <p  className={classNames(styles.box, className)}>
            {duration}
        </p>
    );
};

export default FJMediaDuration;
